import { Network, Loader2, Lock, Activity } from 'lucide-react';
import { useMesh } from '../hooks/useMesh';
import { StatCard } from '../components/StatCard';

export function MeshPage() {
  const { data, isLoading } = useMesh();

  if (isLoading) {
    return <div className="flex items-center justify-center py-20"><Loader2 className="w-5 h-5 text-zinc-600 animate-spin" /></div>;
  }

  if (!data) return null;

  return (
    <div className="space-y-6">
      {/* Stats */}
      <div className="grid grid-cols-3 gap-3">
        <StatCard label="Mesh Agents" value={data.agents.length} />
        <StatCard label="Reservations" value={data.reservations.length} />
        <StatCard label="Feed Events" value={data.feed.length} />
      </div>

      {/* Agents */}
      {data.agents.length > 0 && (
        <section>
          <h3 className="text-xs font-semibold text-zinc-400 uppercase tracking-wide mb-2 flex items-center gap-1.5">
            <Network className="w-3.5 h-3.5" /> Agents
          </h3>
          <div className="space-y-1.5">
            {data.agents.map(a => (
              <div key={a.id} className="bg-surface border border-border rounded-lg px-4 py-2.5 flex items-center gap-3">
                <span className="text-sm font-medium text-zinc-200">{a.name}</span>
                <code className="text-[10px] text-zinc-600 font-mono">{a.id}</code>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* Reservations */}
      {data.reservations.length > 0 && (
        <section>
          <h3 className="text-xs font-semibold text-zinc-400 uppercase tracking-wide mb-2 flex items-center gap-1.5">
            <Lock className="w-3.5 h-3.5" /> Reservations
          </h3>
          <div className="space-y-1.5">
            {data.reservations.map((r, i) => (
              <div key={i} className="bg-surface border border-border rounded-lg px-4 py-2.5 flex items-center gap-3">
                <code className="text-xs font-mono text-zinc-300">{r.path}</code>
                <span className="text-[10px] text-zinc-500">{r.mode}</span>
                <code className="text-[10px] text-zinc-600 font-mono ml-auto">{r.agentId}</code>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* Feed */}
      {data.feed.length > 0 && (
        <section>
          <h3 className="text-xs font-semibold text-zinc-400 uppercase tracking-wide mb-2 flex items-center gap-1.5">
            <Activity className="w-3.5 h-3.5" /> Activity Feed
          </h3>
          <div className="space-y-1">
            {data.feed.slice(0, 30).map((e, i) => (
              <div key={i} className="flex items-center gap-3 px-3 py-1.5 text-[11px] text-zinc-500 bg-surface rounded border border-border/50">
                <span className="text-zinc-400 font-medium">{e.type}</span>
                <span>{e.agentName ?? e.agentId}</span>
                <span className="ml-auto text-zinc-600">{new Date(e.timestamp).toLocaleTimeString()}</span>
              </div>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
